import request from '@/utils/request'

// 根据申请单号，查询申请明细列表信息
export function getDetailInfoByDocCode(docCode, type) {
  const suffix = type ? '/' + type : ''
  return request({
    url: '/api/srm-slcm/pmMatCostApplyLine/getDetailInfoByDocCode/' + docCode + suffix,
    method: 'get'
  })
}

// 根据申请单id，校验成本构成信息
export function checkComposeInfo(id) {
  return request({
    url: '/api/srm-slcm/pmMatCostApplyLine/checkComposeInfo/' + id,
    method: 'get'
  })
}

// 根据申请单id，校验大宗物料信息
export function checkCommodityInfo(id) {
  return request({
    url: '/api/srm-slcm/pmMatCostApplyLine/checkCommodityInfo/' + id,
    method: 'get'
  })
}
